import React, { Component } from 'react';
import { Button, Table, Jumbotron, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Auth from '../middleware/auth';
//import funciones from '../middleware/funciones';
import Menu from './menu';
import config from '../config';
import { saveAs } from 'file-saver';

class Reportes extends Component {
  constructor(props) {
    super(props);
    const currentCompany = sessionStorage.getItem('company');
    const currentUserType = sessionStorage.getItem('tipo');
    const state = Auth.isAuthenticated()
    this.state = {
      documentos: [],
      empresa: currentCompany,
      tipo: currentUserType,
      isLogin: state,
      searchTipo: "",
      searchNumero: "",
      searchCliente: "",
      searchTransaccion: "",
      searchDian: ""
    };
  }

  componentDidMount() {
    const { empresa } = this.state
    const { tipo } = this.state

    const datasend = {
      method: 'GET',
      headers: {
        'empresa': empresa,
        'tipo': tipo,
      }
    }
    fetch(config.servBackEnd + '/documents/history', datasend)
      .then(res => res.json())
      .then((data) => {
        const datos = data.data;
        this.setState({ documentos: datos });
      })
      .catch((error) => console.error(error))
  };

  buscar = ({ target }) => {
    const { name, value } = target;
    this.setState({ [name]: value });
  };

  getPDF = ({ target }) => {
    target.disabled = true;
    const { empresa } = this.state;
    const celda = target.parentElement;
    const fila = celda.parentElement;
    const datos = fila.children;
    const id = datos["id"].textContent;
    const tipo = datos["tipo"].textContent;
    const numero = datos["numero"].textContent;
    const nombreArchivo = tipo + '-' + numero + '.pdf';

    const datasend = {
      method: 'GET',
      headers: {
        'Content-Type': 'blob',
        'empresa': empresa,
        'hist' : '2'
      }
    }
    fetch(config.servBackEnd + '/files/getpdf/' + id, datasend)
      .then((res) => {
        if (res.ok) return res.blob();
      })
      .then((blob) => {
        if (blob) {
          const file = new Blob([blob], { type: 'application/pdf' });
          saveAs(file, nombreArchivo);
        } else {
          //console.log("Archivo Inexistente");
        }
        target.disabled = false;
      })
      .catch((err) => {
        console.error(err);
        target.disabled = false;
      })
  };

  /* mailerDoc = ({ target }) => {
    target.disabled = true;
    const { empresa } = this.state;

    let docSend = []
    if (target.name !== "enviarCorreoTodo") {
      const celda = target.parentElement;
      const fila = celda.parentElement;
      const datos = fila.children;
      docSend = [{
        ID_FACTURA: datos["id"].textContent
      }]
    } else {
      docSend = this.state.docToSend;
    }
    const datasend = {
      method: 'POST',
      body: JSON.stringify(docSend),
      headers: {
        'Content-Type': 'application/json',
        'empresa': empresa
      }
    }
    if (docSend.length > 0) {
      fetch(config.servBackEnd + '/files/createsend', datasend)
        .then(res => res.json())
        .then((data) => {
          //console.log(data);
          let tmpDocumentos = this.state.documentos;
          let tmpPendientes = this.state.docToSend;
          data.forEach(elementData => {
            if (elementData.estado === "4") {
              tmpPendientes.forEach((elementPend, i) => {
                if (elementData.ID_FACTURA.toString() === elementPend.ID_FACTURA.toString()) {
                  delete tmpPendientes[i];
                }
              });
            }
            tmpDocumentos.forEach(elementDoc => {
              if (elementDoc.ID_FACTURA.toString() === elementData.ID_FACTURA.toString()) {
                elementDoc.DOCUMENTO_ENVIADO = elementData.estado;
                elementDoc.DOCUMENTO_ENVIADO_OBSERVACION = elementData.mensaje;
              }
            });
          });
          target.disabled = false;
          tmpPendientes = funciones.limpiarArray(tmpPendientes);
          this.setState({ documentos: tmpDocumentos, docToSend: tmpPendientes });
        })
        .catch((error) => console.error(error))
    } else {
      //console.log("sin documentos pendientes por enviar");
      target.disabled = false;
    }
  }; */

  render() {
    //variables
    const facturas = this.state.documentos;
    const validacionUser = this.state.isLogin;
    const searchTipo = this.state.searchTipo;
    const searchDian = this.state.searchDian;
    const searchNumero = this.state.searchNumero;
    const searchCliente = this.state.searchCliente;
    const searchTransaccion = this.state.searchTransaccion;
    //funciones
    //const mailerDoc = this.mailerDoc;
    const getPDF = this.getPDF;
    return (
      <div className="Menu">
        <Menu></Menu>
        <Jumbotron className="Jumbotron">
          <h2>Historial Facturas</h2>
        </Jumbotron>
        {!validacionUser && <p>La sesion se ha cerrado por favor ingrese de nuevo</p>}
        {validacionUser &&
          <div>
            <Table hover bordered responsive size="sm" className="table">
              <thead>
                <tr>
                  <th><input type="text" name="searchTipo" onChange={this.buscar} /></th>
                  <th><input type="text" name="searchDian" onChange={this.buscar} /></th>
                  <th><input type="text" name="searchNumero" onChange={this.buscar} /></th>
                  <th><input type="text" name="searchCliente" onChange={this.buscar} /></th>
                  <th><input type="text" name="searchTransaccion" onChange={this.buscar} /></th>
                </tr>
                <tr>
                  <th>Tipo Documento</th>
                  <th>Prefijo Dian</th>
                  <th>Numero Documento</th>
                  <th>Nombre Cliente</th>
                  <th>No Transaccion</th>
                  <th colSpan="2">Acciones</th>
                </tr>
              </thead>
              <tbody>
                {facturas && facturas.map(function (currentData, index) {
                  if (currentData.TIPO_DOCUMENTO_CABECERA.toLowerCase().search(searchTipo.toLowerCase()) > -1
                    && currentData.PREFIJO_DIAN.toLowerCase().search(searchDian.toLowerCase()) > -1
                    && currentData.NUMERO_FACTURA_CABECERA.toLowerCase().search(searchNumero.toLowerCase()) > -1
                    && currentData.DOCUMENTO_CLIENTE.toLowerCase().search(searchCliente.toLowerCase()) > -1
                    && currentData.ID_TRANSACCION.toLowerCase().search(searchTransaccion.toLowerCase()) > -1
                  ) {
                    return <tr key={index + "d0"}>
                      <td name="tipo" key={index + "d1"}>{currentData.TIPO_DOCUMENTO_CABECERA}</td>
                      <td name="tipo" key={index + "d2"}>{currentData.PREFIJO_DIAN}</td>
                      <td name="numero" key={index + "d3"}>{currentData.NUMERO_FACTURA_CABECERA}</td>
                      <td name="cliente" key={index + "d4"}>{currentData.DOCUMENTO_CLIENTE}</td>
                      <td name="transaccion" key={index + "d5"}>{currentData.ID_TRANSACCION}</td>
                      <OverlayTrigger placement='top-start' overlay={<Tooltip>Descargar Representacion Grafica</Tooltip>}>
                        <td key={index + "d10"}><Button className="buttonP" onClick={getPDF} variant="outline-primary"></Button></td>
                      </OverlayTrigger>
                      {/* <OverlayTrigger placement='top-start' overlay={<Tooltip>Enviar Correo al Cliente</Tooltip>}>
                        <td key={index + "d13"}><Button className="buttonE" onClick={mailerDoc} disabled={!(currentData.DOCUMENTO_ENVIADO === "2" || currentData.DOCUMENTO_ENVIADO === "4")} variant="outline-primary"></Button></td>
                      </OverlayTrigger> */}
                      <td name="id" className="d-none" key={index + "d14"}>{currentData.ID_FACTURA}</td>
                    </tr>;
                  } else {
                    return <tr key={index + "f0"}></tr>
                  }
                })}
              </tbody>
            </Table>
          </div>
        }
      </div>
    );
  }
}
export default (Reportes);